import { render, staticRenderFns } from "./TextareaAutosized.vue?vue&type=template&id=682d9832"
import script from "./TextareaAutosized.vue?vue&type=script&lang=js"
export * from "./TextareaAutosized.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports